import { TDocumentConfidenceLevel } from './types';

/**
 * The "what do you do now" sentence rendered beneath a document confidence card's statement, for
 * the levels that need one. **Compliance load bearing**, not ordinary UI copy: verifime-adr#264
 * records that changing one of these two sentences is a compliance decision, not a wording
 * preference.
 *
 * `Partial<Record<>>`, not a full `Record`, because three of the five document levels carry no next
 * step at all: the design shows the guidance box only at `NotCompleted` and `Low`. A missing key
 * must resolve to `undefined` and be handled by the caller, the same convention
 * `EvidenceFindings.tsx`'s `LIVENESS_DETERMINATION_LABELS` already uses. There is no biometric
 * equivalent: the prototype populated its `guidance` field on the document axis only.
 *
 * These two sentences were lost on 6 August, when the prototype's confidence copy was re-read off
 * its *rendered* page rather than out of `constants.ts`'s copy table. The prototype's copy table
 * carries two fields per level: `statement` (what happened, transcribed into `statements.ts`) and
 * an optional `guidance` (what the client should do next, transcribed here). Reading the rendered
 * page rather than the source table produced a one-string-per-level model that had no place to put
 * the second field, and it was silently dropped. No decision to drop it exists anywhere: the vault,
 * the knowledge base, the ADRs and the git history were all searched and none records one.
 * verifime-adr#264 restores the two sentences this cost.
 */
export const documentNextStepGuidance: Partial<Record<TDocumentConfidenceLevel, string>> = {
  NotCompleted:
    'No action is needed from you while these checks complete. This page will update automatically once a result is available.',
  Low: 'Documents provided did not meet the verification checks. This does not necessarily mean the document is invalid.',
};
